import { useFeatureToggle } from '../featureFlags/useFeatureToggle';
import { useUser } from './useUser';

export interface IncrementalAuthDeprecation {
    /**
     * `true` once the deprecation messaging is switched on. Use this on the sign in
     * screens, where nobody is signed in yet and so the login method isn't known.
     */
    isAnnounced: boolean;
    /**
     * `true` when the messaging is on *and* the signed in user is using incremental
     * authentication. Use this for messaging aimed only at the clients affected.
     */
    affectsCurrentUser: boolean;
}

/**
 * Incremental authentication is being retired in favour of the Universal Authentication
 * System (UAS). Clients signing in with it need to know before it is removed.
 *
 * The messaging is gated on a per stage feature flag, so it can be released ahead of the
 * announcement and turned on when the business is ready. It is purely informational: no
 * removal date is stated, because the sunset date has not been agreed.
 */
export const useIncrementalAuthDeprecation = (): IncrementalAuthDeprecation => {
    const isAnnounced = !!useFeatureToggle('incrementalAuthDeprecationEnabled');
    const user = useUser();

    return {
        isAnnounced,
        affectsCurrentUser: isAnnounced && !!user?.isIncrementalUser(),
    };
};

export default useIncrementalAuthDeprecation;
